import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Download: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m585 630h-390c-41.36 0-75-33.64-75-75v-105h30v105c0 24.81 20.19 45 45 45h390c24.81 0 45-20.19 45-45v-105h30v105c0 41.36-33.64 75-75 75z' />
    <path d='m390 516.53-115.76-119.16 21.52-20.9 94.24 97 94.24-97 21.52 20.9z' />
    <path d='m375 150v340s30 0 30 0v-310c0-16.57-13.43-30-30-30z' />
  </IconBase>
));

Download.displayName = 'Download';

export default Download;
